import { OnboardingFormActions } from '../../../enums'
import { SetIsAutosaveUpdatingAction } from '../../../types/actions'

export const setIsAutosaveUpdating = (isUpdating: boolean): SetIsAutosaveUpdatingAction => ({
  type: OnboardingFormActions.SET_IS_AUTOSAVE_UPDATING,
  payload: isUpdating
})
